<app-registrations [hideList]=true [determinantMapById]=determinantMapById>
    <registration-description [serviceId]="serviceId"
                              (modalClosedEvent)="navigateToRegistration($event)">
    </registration-description>
</app-registrations>